import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorScreen = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Set a timeout to redirect to home page after 3 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/');
    }, 3000);
    
    // Clean up the timer if component unmounts
    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="error-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#e53e3e' }}>
        Error 404
      </h1>
      <p style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>
        Esto no existe
      </p>
      <p style={{ fontSize: '1rem', color: '#718096' }}>
        Redirigiendo a la página principal en 3 segundos...
      </p>
    </div>
  );
};

export default ErrorScreen;